import { UpscopeProvider as Upscope } from "@upscopeio/react";
import { useProductContext } from "context/ProductContext";

const UPSCOPE_PUBLIC_API_KEY = "BBBtYLCapr";
const UPSCOPE_ENABLED = true;

const UpscopeProvider = ({ children }) => {
    const { isMLTA } = useProductContext();

    if (!isMLTA) return children;

    return (
        <Upscope apiKey={UPSCOPE_PUBLIC_API_KEY} enabled={UPSCOPE_ENABLED}>
            {children}
        </Upscope>
    );
};

export default UpscopeProvider;
